import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Reasignarlo ")
const _hoisted_3 = { class: "d-flex pt-2 pb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Cancelar", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Asignar ")

import { Form } from "vee-validate";
import { onMounted, ref } from "vue";
import Modal from "@/components/Modal.vue";
import Select from "@/components/Inputs/Select.vue";
import { TicketModule } from "@/store/modules/Ticket";
import { schemaAccount } from "@/store/schemas/ticket.shema";
import { ModalSidebarState as ModalState } from "@/types/components";
import { coreApi } from "@/conection";
// props

export default /*#__PURE__*/_defineComponent({
  props: {
    open: { type: Boolean },
    type: null
  },
  emits: ["changeModal"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "changeModal", t: ModalState): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { open: boolean; type: ModalState["type"] }


// emits


// State data
const accounts = ref<Array<any>>([]);
const model = ref<string>();
const checkModel = ref<boolean>(true);
const loading = ref(false);
const options = ref<
	Array<{ value: any; label: string; disabled?: boolean }>
>([]);

async function onSubmit(e: { account: string, reasign: boolean }) {
	if(props.type === 'ticket') {
		const payload = {
			ticket: TicketModule.currentRoomID,
		 	account: e.account,
			reasign: e.reasign,
		}
		coreApi.post('api/account/ticket/change', payload).then(() => {
			emits('changeModal', { show: false })
		})
	} else {
		const payload = {
			client: TicketModule.currentRoom?.users[0]._id,
			account: e.account,
			ticket: TicketModule.currentRoomID,
		}
		coreApi.post('api/account/client/change', payload).then(() => {
			emits('changeModal', { show: false })
		})
	}
}
onMounted(async () => {
    const response = await coreApi.post("/api/account/list");
    accounts.value = response.data.accounts 
	if(accounts.value.length >= 1) {
		if(props.type === 'client')
			accounts.value.unshift({ _id: 'null', name: 'Desasignar' })
		options.value = accounts.value.map((a: any) => ({
			value: a,
			label: a.name,
		}));
	}
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_base_checkbox = _resolveComponent("base-checkbox")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(Modal, {
    show: props.open,
    "modal-classes": "modal-secondary",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('changeModal', { show: false }))),
    "body-classes": "py-0",
    style: {"animation-duration":"0.3s"},
    "modal-content-classes": "bg-gradient-secondary"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, _toDisplayString(props.type === 'ticket' ?
					`Ticket de ${_unref(TicketModule).currentRoom?.users[0].username}` :
					_unref(TicketModule).currentRoom?.users[0].username), 1)
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_unref(Form), {
        "validation-schema": _unref(schemaAccount)(),
        onSubmit: _cache[2] || (_cache[2] = (e) => onSubmit(e))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Select, {
              name: "account",
              label: 
						__props.type === 'ticket' ?
							'Seleccione la cuenta que le asignara al ticket' :
							'Seleccione la cuenta que le asignara al cliente'
					,
              placeholder: "Seleccione una cuenta",
              "label-classes": "text-muted h5 font-weight-normal",
              "addon-left-icon": "fas fa-user-plus",
              "form-group-classes": "mb-2",
              value: model.value,
              "select-options": {
						options: options.value,
						noDataText: 'Sin cuentas',
						valueKey: '_id',
						multiple: false,
					},
              alternative: ""
            }, {
              default: _withCtx((slotProp) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProp.options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value?._id,
                    label: item.value?.name,
                    value: item.value?._id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["label", "value", "select-options"]),
            (__props.type === 'ticket')
              ? (_openBlock(), _createBlock(_component_base_checkbox, {
                  key: 0,
                  name: "reasign",
                  modelValue: checkModel.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkModel).value = $event))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_base_button, {
                type: "link",
                onClick: _cache[1] || (_cache[1] = () => emits('changeModal', { show: false }))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_base_button, {
                type: "primary",
                loading: loading.value,
                "native-type": "submit",
                class: "ml-auto"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})